import { MemberTypes } from '../../models/ss-api/responses/login.response';
import { GlobalServices } from '../../services/global.service';
import { Component, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmDialogComponent } from 'app/dialogs/confirm/confirm-dialog.component';

import { ssApiService } from '../../services/ss-api.service';
import { UpgradeProductRequest } from '../../models/ss-api/requests/upgrade.product.request';
import { BillingRecurringTypes } from '../../models/ss-api/price.billing.cycle';
import { RegisterForTrainingEventRequest } from '../../models/ss-api/requests/register.for.training.event.request';
import { TrainingCalendarRequest } from '../../models/ss-api/requests/training.calendar.request';
import { MemberTrainingCertificatesRequest } from '../../models/ss-api/requests/member.training.certificates.request';
import { UpdateTrainingEventSubscriptionStatusRequest } from '../../models/ss-api/requests/update.training.event.subscription.status.request';
import { AttendanceStatusTypes } from '../../models/domain/training.event.subscription';
import { UpdateCreditCardExpirationRequest } from '../../models/ss-api/requests/update.credit.card.expiration.request';
import { CheckForExistingMemberRequest } from '../../models/ss-api/requests/check.for.existing.member.request';
import { GetTrainingClassesRequest } from 'app/models/ss-api/requests/get.training.classes.request';
import { HoldRequest } from 'app/models/ss-api/requests/hold.request';
import { ResumeLicenseRequest } from 'app/models/ss-api/requests/resume.license.request';
import { ResumeLicenseSimulationRequest } from 'app/models/ss-api/requests/resume.license.simulation.request';
import { UpdateMemberProfileRequest } from 'app/models/ss-api/requests/update.member.profile.request';
import { AddCreditCardRequest } from 'app/models/ss-api/requests/add.credit.card.request';
import { CreditCardTypes } from 'app/models/ss-api/responses/credit.card.response';
import { environment } from 'environments/environment';


@Component({
    selector: 'app-globals',
    templateUrl: './globals.component.html',
    styleUrls: ['./globals.component.css'],
    providers: [DialogService]
})
export class GlobalsComponent implements OnInit {

    EnvName: string;
    BaseUrl: string;

    constructor(private dialogService: DialogService, public gb: GlobalServices, public api: ssApiService) {
        this.BaseUrl = api.GetBaseURL();
        this.EnvName = environment.envName;
    }


    ngOnInit() {
        // this.showReactivateDialog();
    }


    MemberTypeToString(type: MemberTypes): string {
        return MemberTypes[type];
    }

    showDialog() {
        this.dialogService.open(ConfirmDialogComponent, {data: {
            message: 'This is a confirm dialog',
			title: 'Confirm Dialog',
			subTitle: ''
        }});

    }

    showReactivateDialog() {
        /*
        var dialog = this.dialogService.addDialog(ReactivateCDKeyDialogComponent, {
			title: "Title",
			License:
		})
        */
    }

    simulateUpgrade() {
        let request = new UpgradeProductRequest();
        request.CreditCardID = 17;
        request.Initials = 'mm';
        request.LicenseKey = '4C4A7-2AC58-6C4A7';
        request.NewBillingCycle = BillingRecurringTypes.Yearly;
        request.NewProductID = 5;
        request.SimulateOnly = true;

        this.api.ProductsUpgrade(request).subscribe((response) => {
            console.log('Your YEARLY UPGRADE response is: ', response);
        });

        request.NewBillingCycle = BillingRecurringTypes.Monthly;
        request.SimulateOnly = true;
        this.api.ProductsUpgrade(request).subscribe((response) => {
            console.log('Your MONTHLY UPGRADE response is: ', response);
        });
    }

    CheckForExistingMember() {
        let request = new CheckForExistingMemberRequest();
        request.Email = 'tanyatest@structurestudios.com';
        request.Checksum = 'ADSFEWFF~!OMG1ITS5SNOWING3INVEGAS42!!!AND6ALL4FROZEN7DRINKS3ARE22HALF00OFF43IN65THE998CASINO';
        let subscription = this.api.CheckForExistingMember(request).subscribe(result => {

            subscription.unsubscribe();

            console.log('CheckForExistingMember-', result);
        });
    }

    CheckHoldEligibility() {
        let subscription = this.api.CheckHoldEligibility('MSGWF-584ES-8975S').subscribe(result => {

            subscription.unsubscribe();

            console.log('CheckHoldEligibility Result -', result);
        });

    }

    SetOnHold1(){
        console.log("Set on hold 1");

        let request = new HoldRequest();
        request.CreditCardID = 18738;
        request.HoldItemID = 5;
        request.Initials = "FC";
        request.LicenseKey = "MSGWF-584ES-8975S";

        let subscription = this.api.HoldLicense(request).subscribe(result => {

            subscription.unsubscribe();

            console.log('Hold Result -', result);
        });

    }

    SetOnHold2(){
        console.log("Set on hold 2");

        let request = new HoldRequest();
        request.CreditCardID = 18738;
        request.HoldItemID = 6;
        request.Initials = "FC";
        request.LicenseKey = "MSGWF-584ES-8975S";

        let subscription = this.api.HoldLicense(request).subscribe(result => {

            subscription.unsubscribe();

            console.log('Hold Result -', result);
        });
    }

    SetOnHold3(){
        console.log("Set on hold 3");

        let request = new HoldRequest();
        request.CreditCardID = 18738;
        request.HoldItemID = 8;
        request.Initials = "tt";
        request.LicenseKey = "MSGWF-584ES-8975S";

        let subscription = this.api.HoldLicense(request).subscribe(result => {

            subscription.unsubscribe();

            console.log('Hold Result -', result);
        });
    }

    
    ExtendHold1(){
        console.log("Extend hold 1");
    }
    
    ExtendHold2(){
        console.log("Extend hold 2");
    }
    
    ExtendHold3(){
        console.log("Extend hold 3");

        let request = new HoldRequest();
        request.CreditCardID = 18738;
        request.HoldItemID = 6;
        request.Initials = "dd";
        request.LicenseKey = "MSGWF-584ES-8975S";

        let subscription = this.api.ExtendHoldLicense(request).subscribe(result => {

            subscription.unsubscribe();

            console.log('Extend Hold Result -', result);
        }); 
    }
    
    ResumeLicense1(){
        console.log("Resume License 1");
    }
       
    ResumeLicense2(){
        console.log("Resume License 2");
    }
       
    ResumeLicense3(){
        console.log("Resume License 3");

        let request = new ResumeLicenseRequest();
        request.LicenseKey = "MSGWF-584ES-8975S";
        request.CreditCardID = 18738;
        request.Initials = "dd";

        let subscription = this.api.ResumeLicense(request).subscribe(result => {

            subscription.unsubscribe();

            console.log('Resume License Result -', result);
        }); 

    }  
    
    ResumeLicenseSimulation1(){
        console.log("Resume License Simulation 1");
    }
       
    ResumeLicenseSimulation2(){
        console.log("Resume License Simulation 2");
    }
       
    ResumeLicenseSimulation3(){
        console.log("Resume License Simulation 3");

        let request = new ResumeLicenseSimulationRequest();
        request.LicenseKey = "MSGWF-584ES-8975S";
        request.Initials = "dd";

        let subscription = this.api.ResumeLicenseSimulation(request).subscribe(result => {

            subscription.unsubscribe();

            console.log('Resume License Simulation Result -', result);
        }); 

    }  

    GetTrainingClasses() {
        let request = new GetTrainingClassesRequest();
        request.Checksum = '543PikaChuuuuuuuuuuuuuuuuuuuuuuuuuuuuuu!!!%$#';
        let subscription = this.api.GetTrainingClasses(request).subscribe(result => {

            subscription.unsubscribe();

            console.log('GetTrainingClasses-', result);
        });
    }

    GetTrainingCalendar() {
        let StartDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        let EndDate = new Date();
        let request = new TrainingCalendarRequest();
        request.StartDate = StartDate;
        request.EndDate = EndDate;
        let subscription = this.api.GetMemberTrainingCalendar(request).subscribe(result => {

            subscription.unsubscribe();

            console.log('calendar', result);
        });
    }

    GetTrainingHistory() {
        let subscription = this.api.GetTrainingHistory().subscribe(result => {

            subscription.unsubscribe();

            console.log('traininghistory-result', result);
        });

    }

    GetMemberTrainingCertificates() {
        let StartDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        let EndDate = new Date();

        let request = new MemberTrainingCertificatesRequest();
        request.StartDate = StartDate;
        request.EndDate = EndDate;

        let subscription = this.api.GetMemberTrainingCertificates(request).subscribe(result => {

            subscription.unsubscribe();

            console.log('first AttendeeFullName', result.Data[0].AttendeeFullName);
            console.log('certs', result);
        });
    }


    RegisterForTrainingEvent() {
        let request = new RegisterForTrainingEventRequest();
        request.AlternateEmail = 'alt@email.com';
        request.AlternatePhone = '702-867-5309';
        request.LicenseID = 25993;  //Fausto
        request.TrainingEventID = 9; //Any valid Training Event
        let sub2 = this.api.RegisterForTrainingEvent(request).subscribe(result => {

            sub2.unsubscribe();

            console.log('trainingevent', result);
        });

    }


    CancelSubStatus() {
        let request = new UpdateTrainingEventSubscriptionStatusRequest();
        request.TrainingEventSubscriptionID = 4319;
        request.AttendanceStatusType = AttendanceStatusTypes.Cancelled;
        let sub2 = this.api.UpdateTrainingEventSubscriptionStatus(request).subscribe(result => {

            sub2.unsubscribe();

            console.log('cancelsubresult', result);
        });

    }

    UpdateCCExpiration() {
        let request = new UpdateCreditCardExpirationRequest();
        request.CreditCardID = 341528;
        request.ExpMonth = 4;
        request.ExpYear = 2024;
        let sub2 = this.api.CreditCardUpdateExpiration(request).subscribe(result => {

            sub2.unsubscribe();

            console.log('CreditCardUpdateExpiration-result:', result);
        });

    }

    RescheduleSubStatus() {
        let request = new UpdateTrainingEventSubscriptionStatusRequest();
        request.TrainingEventSubscriptionID = 4319;
        request.AttendanceStatusType = AttendanceStatusTypes.Rescheduled;
        let sub2 = this.api.UpdateTrainingEventSubscriptionStatus(request).subscribe(result => {

            sub2.unsubscribe();

            console.log('RescheduleSubStatusresult', result);
        });

    }

   
    AddCreditCard() {
        let request = new AddCreditCardRequest();

        request.UpdateMemberAddress = true;

        request.Address01 = "123 Visa Lane";
        request.CVV = 123;
        request.CardType = CreditCardTypes.VISA;
        request.City = "Masterton";
        request.Country = "US";
        request.CreditCardNumber = "4111111111111111";
        request.ExpMonth = 1;
        request.ExpYear = 2025;
        request.FirstName = "Faaake";
        request.LastFour = "1111";
        request.LastName = "Caaard";
        request.SetAsDefault = false;
        request.State = "CA";
        request.ZipCode = "90210";
        let sub2 = this.api.CreditCardAdd(request).subscribe(result => {

            sub2.unsubscribe();

            console.log('CreditCardAdd', result);
        });

    } 

    MemberProfile() {
        let subscription = this.api.MemberProfile().subscribe(result => {

            subscription.unsubscribe();

            console.log('MemberProfile Result -', result);
        });

    }

    UpdateMemberProfile()
    {
        let request = new UpdateMemberProfileRequest();

        request.Companyname = "String and Things";

        request.Email = null; //A null indicates no change.  To clear a field, pass an empty string.

        request.Address1 = "123 El Camino Parkway";
        request.City = "Hayward";
        request.State = "CA";
        request.Postcode = "94567";
        request.Country = null;
        
        request.Phonenumber = "702-867-5309";
        request.Phonenumber2 = null;
        request.FaxNumber = "702-555-3339";

        request.CurrentPassword = null;
        request.NewPassword = null;

        let subscription = this.api.UpdateMemberProfile(request).subscribe(result => {

            subscription.unsubscribe();

            console.log('UpdateMemberProfile-', result);
        });
    } 

}
